import { useQuery } from '@apollo/client'
import useVisibleRefresh from '../hooks/useVisibleRefresh'

export function useVisibleQuery(query, { pollInterval, ...options } = {}) {
    const result = useQuery(query, options)
    useVisibleRefresh(() => {
        // Apollo exposes failures through result.error; handle the promise too.
        result.refetch().catch(() => {})
    }, pollInterval)
    return result
}

export default function VisibleQuery({ query, children, ...options }) {
    return children(useVisibleQuery(query, options))
}
